import { jsx as c } from "react/jsx-runtime";
import { useState as p, useRef as f, useCallback as u } from "react";
import m from "../_virtual/copy.js";
import d from "../_virtual/copy-check.js";
import { ButtonArea as y } from "../ButtonArea/ButtonArea.js";
import { css as h } from "../apps/ui/styled-system/css/css.js";
function a({ size: o = "small", value: i }) {
  const { copy: t, notifying: r } = a.useCopy(), e = r ? d : m;
  return o === "small" && (o = 14), /* @__PURE__ */ c(
    y,
    {
      className: h({
        alignItems: "center",
        borderRadius: 2,
        color: "var(--text-color-th_base-secondary)",
        display: "flex",
        flexShrink: 0,
        height: 16,
        justifyContent: "center",
        paddingBottom: 1,
        position: "relative",
        width: 16
      }),
      onClick: () => t(i),
      title: r ? "Copied" : "Copy to clipboard",
      children: /* @__PURE__ */ c(e, { height: o, width: o })
    }
  );
}
((o) => {
  function i(t = 800) {
    const [r, e] = p(!1), n = f(null);
    return { copy: u(
      async (s) => {
        n.current && clearTimeout(n.current);
        try {
          if (!navigator.clipboard)
            throw new Error("Clipboard API not supported");
          await navigator.clipboard.writeText(s), e(!0), n.current = setTimeout(() => e(!1), t);
        } catch (l) {
          console.error("Failed to copy text: ", l);
        }
      },
      [t]
    ), notifying: r };
  }
  o.useCopy = i;
})(a || (a = {}));
export {
  a as CopyButton
};
//# sourceMappingURL=CopyButton.js.map
